<template>
  <div class="search-suggestions" v-if="isVisible">
    <div class="search-suggestions__block" v-if="querySuggestionsData.querySuggestions">
      <span class="search-suggestions__title">{{ $t('search.suggestedSearch') }}</span>
      <ul class="search-suggestions__list">
        <li
          v-for="suggestionItem in querySuggestionsData.querySuggestions"
          :key="suggestionItem.query"
          @click="onResultClick(suggestionItem)"
          class="search-suggestions__item"
        >
          <span class="search-suggestions__query-text">{{ suggestionItem.query }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SearchSuggestions',
  computed: {
    ...mapState('search', ['querySuggestionsData']),
    isVisible () {
      return this.querySuggestionsData?.querySuggestions?.length
    }
  },
  methods: {
    onResultClick (suggestionItem) {
      this.$emit('suggestionSelected', suggestionItem)
    }
  }
}
</script>
